export default {
  NONE: 'none',
  BANDWIDTH: 'bandwidth',
  CPU: 'cpu',
};
